var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2581 1.34489C10.5696 0.784784 9.74847 0.411465 8.87377 0.260914C7.99908 0.110364 7.10035 0.187658 6.2642 0.485348C5.42805 0.783038 4.68268 1.29109 4.09992 1.96053C3.51716 2.62997 3.11667 3.43824 2.93703 4.30743C2.73068 5.2954 2.81952 6.32224 3.19249 7.26009C3.56545 8.19794 4.20605 9.00536 5.03453 9.58181C5.84379 10.1194 6.5492 10.7989 7.11673 11.5874L7.5301 12.1845C7.58276 12.2619 7.65353 12.3252 7.73625 12.369C7.81897 12.4127 7.91114 12.4356 8.00472 12.4356C8.0983 12.4356 8.19047 12.4127 8.27319 12.369C8.35591 12.3252 8.42668 12.2619 8.47934 12.1845L8.89271 11.5798C9.41158 10.8247 10.0719 10.1774 10.8371 9.67367C11.5174 9.22864 12.083 8.62916 12.4876 7.92407C12.8923 7.21899 13.1246 6.42826 13.1656 5.61635C13.2067 4.80444 13.0553 3.99431 12.7238 3.25202C12.3923 2.50972 11.8901 1.85626 11.2581 1.34489Z",
    fill: "#24CA49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 15.5198C10.4313 15.5198 12.402 14.9936 12.402 14.3446C12.402 13.6956 10.4313 13.1694 8.00033 13.1694C5.56934 13.1694 3.59863 13.6956 3.59863 14.3446C3.59863 14.9936 5.56934 15.5198 8.00033 15.5198Z",
    fill: "#24CA49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00041 7.13509C9.19702 7.13509 10.1671 6.16504 10.1671 4.96842C10.1671 3.77181 9.19702 2.80176 8.00041 2.80176C6.80379 2.80176 5.83374 3.77181 5.83374 4.96842C5.83374 6.16504 6.80379 7.13509 8.00041 7.13509Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartMark);
export default __webpack_public_path__ + "static/media/start_mark.66e302ad7b81b7f99ea1e2dcce46ee06.svg";
export { ForwardRef as ReactComponent };